// Import model
import { FinishUploadResponse } from '../models/FinishUploadResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FinishUploadResponse - handles JSON serialization and deserialization with type validation
 */
export class FinishUploadResponseSerializer {
  /**
   * Deserializes a JSON string into a FinishUploadResponse instance
   */
  static deserialize(json: string): FinishUploadResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FinishUploadResponse instance
   */
  static fromObject(obj: any): FinishUploadResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FinishUploadResponse');
    }


    const instance: FinishUploadResponse = {
      message: obj['Message'] as string | undefined,
      success: obj['Success'] as boolean,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FinishUploadResponse instances
   */
  static deserializeArray(json: string): FinishUploadResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FinishUploadResponse instance to a JSON string
   */
  static serialize(instance: FinishUploadResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FinishUploadResponse instance to a plain object
   */
  static toObject(instance: FinishUploadResponse): any {
    return {
      'Message': instance.message,
      'Success': instance.success,
    };
  }

  /**
   * Serializes an array of FinishUploadResponse instances to a JSON string
   */
  static serializeArray(instances: FinishUploadResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
